import { v4 as uuidv4 } from 'uuid'
const Images = [
    /*{
      category: "Youtube", 
       imgsrc: "./Images/",
       title: "Poster",
       id: uuidv4(),
       link: "", 
   },*/
    /*{
        category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        brand_name: "", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        brand_name: "", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
       category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
       category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
       category: "Youtube",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Youtube", 
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    /*{
        category: "Youtube",category: "Youtube",
        imgsrc: "./Images/",
        title: "Poster",
        id: uuidv4(),
        link: "", 
    },*/
    {
        category: "Youtube", 
        imgsrc: "./Images/website_images/image_5.jpg",
        title: "Poster",
        id: uuidv4(),
        link: "https://youtube.com/channel/UCpMcsXwMVYqG_Gn8_qRaM3A", 
    },
    {
        category: "Youtube", 
        imgsrc: "./Images/website_images/image_4.jpg",
        title: "Poster",
        id: uuidv4(),
        link: "https://youtube.com/c/iamNoel4", 
    },
    {
        category: "Youtube",
        imgsrc: "./Images/website_images/image_3.jpg",
        title: "Poster",
        id: uuidv4(),
        link: "https://youtube.com/c/AnnsPaperTech",
    },
]
export default Images
